module.exports = __webpack_public_path__ + "img/mastercard-world.923446eb.png";